export default "__VITE_ASSET__892eda9c__"